import { render, staticRenderFns } from "./AssetGroup.vue?vue&type=template&id=27a1c2b8"
import script from "./AssetGroup.vue?vue&type=script&lang=js"
export * from "./AssetGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports